import { ModNavigationItem } from '@moderneinc/design-system-components';
import { spacing } from '@moderneinc/design-system-tokens';
import { Stack } from '@mui/material';
import Link from 'next/link';
import { useRouter } from 'next/router';
import type { FunctionComponent, KeyboardEvent } from 'react';
import { HOME_PAGE_PATH } from '../../../constants/general';
import {
  excludeActionFromInputMode,
  useCommandPalette
} from '../../../hooks/use-command-palette.hooks';
import { ModerneMonogram } from '../../branding/moderne-monogram.component';

export const HomeMenuItem: FunctionComponent = () => {
  const { asPath, push } = useRouter();
  const isSelected = asPath === HOME_PAGE_PATH;

  useCommandPalette({
    label: 'Go to Home',
    action: () => (e: KeyboardEvent<Element>) =>
      excludeActionFromInputMode(e, () => push(HOME_PAGE_PATH)),
    keyboardShortcuts: {
      key: 'H',
      modifier: {
        shift: true
      }
    }
  });

  return (
    <Stack
      sx={{
        alignItems: 'center',
        mt: `${spacing.spacing_1_2}px`
      }}
    >
      <ModNavigationItem
        component={Link}
        prefetch={false}
        href={HOME_PAGE_PATH}
        selected={isSelected}
        aria-current={isSelected ? 'page' : undefined}
        icon={<ModerneMonogram size={28} />}
      />
    </Stack>
  );
};
